// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".base-overlay-node .scene-number{transition:opacity 300ms ease;opacity:1;font-size:.75rem;color:#fff;background-color:#798294;margin-right:4px;padding:0 4px;border-radius:1px;cursor:pointer}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
